module.exports = __webpack_public_path__ + "img/img_level_16.1d45f64a.png";